import $ from 'jquery'

$('.header-base__scroll button').on('click', function () {
  const content = $('.entry-content')

  if (content) {
    $('html, body').animate(
      {
        scrollTop: content.offset().top - 50,
      },
      250
    )
  }
})
